import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-leo-federation",
  "use": "icon-leo-federation-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-leo-federation\">\r\n<g transform=\"translate(-113.571 -113.571) scale(1.221818)\">\r\n<path d=\"M448 160h128v128H448V160zM192 448h128v128H192V448zm512 0h128v128H704V448zM448 736h128v128H448V736z\" />\r\n  <path d=\"M496 288v160H320v-48h-48v112h272V288h-48zm0 288v160h48V576h176v112h48V528H496z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/leo-federation.svg
// module id = ZdSe
// module chunks = 446